var map = {
	"./about-us/banner-img": 40,
	"./about-us/banner-img.jpg": 40,
	"./about-us/info-bg": 41,
	"./about-us/info-bg.jpg": 41,
	"./about-us/team-img": 42,
	"./about-us/team-img.jpg": 42,
	"./about-us/values-img": 43,
	"./about-us/values-img.jpg": 43,
	"./automated-testing/automated-banner-icon": 44,
	"./automated-testing/automated-banner-icon.svg": 44,
	"./automated-testing/benefits/benefits-img1": 45,
	"./automated-testing/benefits/benefits-img1.svg": 45,
	"./automated-testing/benefits/benefits-img2": 46,
	"./automated-testing/benefits/benefits-img2.svg": 46,
	"./automated-testing/benefits/benefits-img3": 47,
	"./automated-testing/benefits/benefits-img3.svg": 47,
	"./automated-testing/benefits/benefits-img4": 48,
	"./automated-testing/benefits/benefits-img4.svg": 48,
	"./automated-testing/benefits/benefits-img5": 49,
	"./automated-testing/benefits/benefits-img5.svg": 49,
	"./automated-testing/benefits/benefits-img6": 50,
	"./automated-testing/benefits/benefits-img6.svg": 50,
	"./automated-testing/benefits/benefits-img7": 51,
	"./automated-testing/benefits/benefits-img7.svg": 51,
	"./careers/vacancies-bg-icon": 52,
	"./careers/vacancies-bg-icon.svg": 52,
	"./careers/why-work/gallery-bg": 53,
	"./careers/why-work/gallery-bg.svg": 53,
	"./careers/why-work/why-work-img1": 54,
	"./careers/why-work/why-work-img1.svg": 54,
	"./careers/why-work/why-work-img2": 55,
	"./careers/why-work/why-work-img2.svg": 55,
	"./careers/why-work/why-work-img3": 56,
	"./careers/why-work/why-work-img3.svg": 56,
	"./careers/why-work/why-work-img4": 57,
	"./careers/why-work/why-work-img4.svg": 57,
	"./careers/why-work/why-work-img5": 58,
	"./careers/why-work/why-work-img5.svg": 58,
	"./careers/why-work/why-work-img6": 59,
	"./careers/why-work/why-work-img6.svg": 59,
	"./careers/why-work/why-work-img7": 60,
	"./careers/why-work/why-work-img7.svg": 60,
	"./careers/why-work/why-work-photo1": 61,
	"./careers/why-work/why-work-photo1.jpg": 61,
	"./careers/why-work/why-work-photo2": 62,
	"./careers/why-work/why-work-photo2.jpg": 62,
	"./careers/why-work/why-work-photo3": 63,
	"./careers/why-work/why-work-photo3.jpg": 63,
	"./careers/why-work/why-work-photo4": 64,
	"./careers/why-work/why-work-photo4.jpg": 64,
	"./clients-modal/baam": 65,
	"./clients-modal/baam.svg": 65,
	"./clients-modal/bit4coin": 66,
	"./clients-modal/bit4coin.svg": 66,
	"./clients-modal/bridebook": 67,
	"./clients-modal/bridebook.svg": 67,
	"./clients-modal/join": 68,
	"./clients-modal/join.svg": 68,
	"./clients-modal/neurala": 69,
	"./clients-modal/neurala.svg": 69,
	"./clients-modal/talendo": 70,
	"./clients-modal/talendo.svg": 70,
	"./clients-modal/together": 71,
	"./clients-modal/together.svg": 71,
	"./clients/client1": 72,
	"./clients/client1.svg": 72,
	"./clients/client10": 73,
	"./clients/client10.svg": 73,
	"./clients/client2": 74,
	"./clients/client2.svg": 74,
	"./clients/client3": 75,
	"./clients/client3.svg": 75,
	"./clients/client4": 76,
	"./clients/client4.svg": 76,
	"./clients/client5": 77,
	"./clients/client5.svg": 77,
	"./clients/client6": 78,
	"./clients/client6.svg": 78,
	"./clients/client7": 79,
	"./clients/client7.svg": 79,
	"./clients/client8": 80,
	"./clients/client8.svg": 80,
	"./clients/client9": 81,
	"./clients/client9.svg": 81,
	"./clients/client__bg": 82,
	"./clients/client__bg.png": 82,
	"./contact-us/offices/flag-germany": 83,
	"./contact-us/offices/flag-germany.png": 83,
	"./contact-us/offices/flag-ukraine": 84,
	"./contact-us/offices/flag-ukraine.png": 84,
	"./contact-us/offices/germany": 85,
	"./contact-us/offices/germany.svg": 85,
	"./contact-us/offices/header-btn-line": 86,
	"./contact-us/offices/header-btn-line.svg": 86,
	"./contact-us/offices/offices-section-bg": 87,
	"./contact-us/offices/offices-section-bg.svg": 87,
	"./contact-us/offices/planet": 88,
	"./contact-us/offices/planet.svg": 88,
	"./contact-us/offices/ukraine": 89,
	"./contact-us/offices/ukraine.svg": 89,
	"./decorations/banner-content-after": 90,
	"./decorations/banner-content-after.svg": 90,
	"./decorations/banner-content-before": 91,
	"./decorations/banner-content-before.svg": 91,
	"./decorations/coaches-img": 92,
	"./decorations/coaches-img.svg": 92,
	"./decorations/contact-us-form-decor": 93,
	"./decorations/contact-us-form-decor.svg": 93,
	"./decorations/course-outline-img1": 94,
	"./decorations/course-outline-img1.svg": 94,
	"./decorations/course-outline-img2": 95,
	"./decorations/course-outline-img2.svg": 95,
	"./decorations/decoration-left-img": 96,
	"./decorations/decoration-left-img.svg": 96,
	"./decorations/decoration-offices-left": 97,
	"./decorations/decoration-offices-left.svg": 97,
	"./decorations/decoration-offices-right": 98,
	"./decorations/decoration-offices-right.svg": 98,
	"./decorations/decoration-right-img": 99,
	"./decorations/decoration-right-img.svg": 99,
	"./decorations/decoration-sidebar": 100,
	"./decorations/decoration-sidebar.svg": 100,
	"./decorations/decoration_left": 101,
	"./decorations/decoration_left.svg": 101,
	"./decorations/decoration_right": 102,
	"./decorations/decoration_right.svg": 102,
	"./decorations/history-bl-img": 103,
	"./decorations/history-bl-img.svg": 103,
	"./decorations/history-year-after": 104,
	"./decorations/history-year-after-desk": 105,
	"./decorations/history-year-after-desk.svg": 105,
	"./decorations/history-year-after.svg": 104,
	"./decorations/history-year-before": 106,
	"./decorations/history-year-before-desk": 107,
	"./decorations/history-year-before-desk.svg": 107,
	"./decorations/history-year-before.svg": 106,
	"./decorations/howitzer-tabs-img1": 108,
	"./decorations/howitzer-tabs-img1.svg": 108,
	"./decorations/howitzer-tabs-img2": 109,
	"./decorations/howitzer-tabs-img2.svg": 109,
	"./decorations/info-img-bg": 110,
	"./decorations/info-img-bg-desk": 111,
	"./decorations/info-img-bg-desk.svg": 111,
	"./decorations/info-img-bg.svg": 110,
	"./decorations/our-services-img": 112,
	"./decorations/our-services-img.svg": 112,
	"./decorations/our-work-left": 113,
	"./decorations/our-work-left.svg": 113,
	"./decorations/our-work-right": 114,
	"./decorations/our-work-right.svg": 114,
	"./decorations/testing-myths-img-left": 115,
	"./decorations/testing-myths-img-left.svg": 115,
	"./decorations/testing-myths-img-right": 116,
	"./decorations/testing-myths-img-right.svg": 116,
	"./decorations/tools-img": 117,
	"./decorations/tools-img.svg": 117,
	"./decorations/type-testing-img": 118,
	"./decorations/type-testing-img.svg": 118,
	"./decorations/vacancies-img-left": 119,
	"./decorations/vacancies-img-left.svg": 119,
	"./decorations/vacancies-img-right": 120,
	"./decorations/vacancies-img-right.svg": 120,
	"./decorations/values-after-img": 121,
	"./decorations/values-after-img.svg": 121,
	"./decorations/why-work-right-img": 122,
	"./decorations/why-work-right-img.svg": 122,
	"./decorations/workers-img-left": 123,
	"./decorations/workers-img-left.svg": 123,
	"./decorations/workers-img-right": 124,
	"./decorations/workers-img-right.svg": 124,
	"./description/contact-us-decoration": 125,
	"./description/contact-us-decoration.svg": 125,
	"./description/description-automated-after": 126,
	"./description/description-automated-after.svg": 126,
	"./description/description-manual-after": 127,
	"./description/description-manual-after.svg": 127,
	"./description/description-services-after": 128,
	"./description/description-services-after.svg": 128,
	"./description/description-sevices-bottom": 129,
	"./description/description-sevices-bottom.svg": 129,
	"./description/description-solution-after": 130,
	"./description/description-solution-after.svg": 130,
	"./description/description-trainings-after": 131,
	"./description/description-trainings-after.svg": 131,
	"./description/galaxy": 132,
	"./description/galaxy-md": 133,
	"./description/galaxy-md.svg": 133,
	"./description/galaxy-sm": 134,
	"./description/galaxy-sm.svg": 134,
	"./description/galaxy.svg": 132,
	"./footer/footer-bg": 135,
	"./footer/footer-bg.svg": 135,
	"./footer/footer-bg.webp": 263,
	"./home/animate/arrow": 136,
	"./home/animate/arrow.svg": 136,
	"./home/animate/item1": 137,
	"./home/animate/item1.svg": 137,
	"./home/animate/item2": 138,
	"./home/animate/item2.svg": 138,
	"./home/animate/item3": 139,
	"./home/animate/item3.svg": 139,
	"./home/animate/mobile/item1": 140,
	"./home/animate/mobile/item1.svg": 140,
	"./home/animate/mobile/item2": 141,
	"./home/animate/mobile/item2.svg": 141,
	"./home/animate/mobile/item3": 142,
	"./home/animate/mobile/item3.svg": 142,
	"./home/animate/screen2": 143,
	"./home/animate/screen2.svg": 143,
	"./home/animate/screen3": 144,
	"./home/animate/screen3.svg": 144,
	"./home/clients-map/b4c": 145,
	"./home/clients-map/b4c.svg": 145,
	"./home/clients-map/baam": 146,
	"./home/clients-map/baam.svg": 146,
	"./home/clients-map/bridebook": 147,
	"./home/clients-map/bridebook.svg": 147,
	"./home/clients-map/hack": 148,
	"./home/clients-map/hack.svg": 148,
	"./home/clients-map/join": 149,
	"./home/clients-map/join.svg": 149,
	"./home/clients-map/map1": 150,
	"./home/clients-map/map1.png": 150,
	"./home/clients-map/map2": 151,
	"./home/clients-map/map2.png": 151,
	"./home/clients-map/map3": 152,
	"./home/clients-map/map3.png": 152,
	"./home/clients-map/map4": 153,
	"./home/clients-map/map4.png": 153,
	"./home/clients-map/neth": 154,
	"./home/clients-map/neth.png": 154,
	"./home/clients-map/neurala": 155,
	"./home/clients-map/neurala.svg": 155,
	"./home/clients-map/og": 156,
	"./home/clients-map/og.svg": 156,
	"./home/clients-map/sw": 157,
	"./home/clients-map/sw.png": 157,
	"./home/clients-map/talendo": 158,
	"./home/clients-map/talendo.svg": 158,
	"./home/clients-map/together": 159,
	"./home/clients-map/together.svg": 159,
	"./home/clients-map/uk": 160,
	"./home/clients-map/uk.png": 160,
	"./home/clients-map/usa": 161,
	"./home/clients-map/usa.png": 161,
	"./home/directions/direction1": 162,
	"./home/directions/direction1.svg": 162,
	"./home/directions/direction2": 163,
	"./home/directions/direction2.svg": 163,
	"./home/directions/direction3": 164,
	"./home/directions/direction3.svg": 164,
	"./home/directions/list-1": 165,
	"./home/directions/list-1.svg": 165,
	"./home/directions/list-10": 166,
	"./home/directions/list-10.svg": 166,
	"./home/directions/list-11": 167,
	"./home/directions/list-11.svg": 167,
	"./home/directions/list-12": 168,
	"./home/directions/list-12.svg": 168,
	"./home/directions/list-2": 169,
	"./home/directions/list-2.svg": 169,
	"./home/directions/list-3": 170,
	"./home/directions/list-3.svg": 170,
	"./home/directions/list-4": 171,
	"./home/directions/list-4.svg": 171,
	"./home/directions/list-5": 172,
	"./home/directions/list-5.svg": 172,
	"./home/directions/list-6": 173,
	"./home/directions/list-6.svg": 173,
	"./home/directions/list-7": 174,
	"./home/directions/list-7.svg": 174,
	"./home/directions/list-8": 175,
	"./home/directions/list-8.svg": 175,
	"./home/directions/list-9": 176,
	"./home/directions/list-9.svg": 176,
	"./home/directions/mobile/direction1": 177,
	"./home/directions/mobile/direction1.svg": 177,
	"./home/directions/mobile/direction2": 178,
	"./home/directions/mobile/direction2.svg": 178,
	"./home/directions/mobile/direction3": 179,
	"./home/directions/mobile/direction3.svg": 179,
	"./home/gallery/gallery1": 180,
	"./home/gallery/gallery1.png": 180,
	"./home/gallery/gallery10": 181,
	"./home/gallery/gallery10.png": 181,
	"./home/gallery/gallery2": 182,
	"./home/gallery/gallery2.png": 182,
	"./home/gallery/gallery3": 183,
	"./home/gallery/gallery3.png": 183,
	"./home/gallery/gallery4": 184,
	"./home/gallery/gallery4.png": 184,
	"./home/gallery/gallery5": 185,
	"./home/gallery/gallery5.png": 185,
	"./home/gallery/gallery6": 186,
	"./home/gallery/gallery6.png": 186,
	"./home/gallery/gallery7": 187,
	"./home/gallery/gallery7.png": 187,
	"./home/gallery/gallery8": 188,
	"./home/gallery/gallery8.png": 188,
	"./home/gallery/gallery9": 189,
	"./home/gallery/gallery9.png": 189,
	"./home/our-work/line": 190,
	"./home/our-work/line.svg": 190,
	"./home/our-work/photo-1-hover.webp": 264,
	"./home/our-work/photo-1.webp": 265,
	"./home/our-work/photo-2-hover.webp": 266,
	"./home/our-work/photo-2.webp": 267,
	"./home/our-work/photo-3-hover.webp": 268,
	"./home/our-work/photo-3.webp": 269,
	"./home/our-work/photo-decoration": 191,
	"./home/our-work/photo-decoration.svg": 191,
	"./home/product/mobile/product1": 192,
	"./home/product/mobile/product1.svg": 192,
	"./home/product/mobile/product2": 193,
	"./home/product/mobile/product2.svg": 193,
	"./home/product/mobile/product3": 194,
	"./home/product/mobile/product3.svg": 194,
	"./home/product/mobile/product4": 195,
	"./home/product/mobile/product4.svg": 195,
	"./home/product/product1": 196,
	"./home/product/product1.svg": 196,
	"./home/product/product2": 197,
	"./home/product/product2.svg": 197,
	"./home/product/product3": 198,
	"./home/product/product3.svg": 198,
	"./home/product/product4": 199,
	"./home/product/product4.svg": 199,
	"./home/product_bg": 200,
	"./home/product_bg.png": 200,
	"./home/product_border": 201,
	"./home/product_border.svg": 201,
	"./home/sections-parralax/clients-parralax": 202,
	"./home/sections-parralax/clients-parralax.svg": 202,
	"./home/sections-parralax/directions-parralax": 203,
	"./home/sections-parralax/directions-parralax.png": 203,
	"./home/sections-parralax/directions-parralax1": 204,
	"./home/sections-parralax/directions-parralax1.png": 204,
	"./icons/accardion-arrow": 205,
	"./icons/accardion-arrow.svg": 205,
	"./icons/check-icon": 206,
	"./icons/check-icon-lg": 207,
	"./icons/check-icon-lg.svg": 207,
	"./icons/check-icon.svg": 206,
	"./logo": 208,
	"./logo.svg": 208,
	"./main_bg": 209,
	"./main_bg.jpg": 209,
	"./main_bg.webp": 270,
	"./manual-testing/manual-banner-icon": 210,
	"./manual-testing/manual-banner-icon.svg": 210,
	"./manual-testing/testing-diagram": 211,
	"./manual-testing/testing-diagram.svg": 211,
	"./manual-testing/testing-process-img": 212,
	"./manual-testing/testing-process-img.svg": 212,
	"./manual-testing/wave": 213,
	"./manual-testing/wave.svg": 213,
	"./marking": 214,
	"./marking.png": 214,
	"./portal/banner-portal-img": 215,
	"./portal/banner-portal-img.svg": 215,
	"./portal/banner-portal-img2": 216,
	"./portal/banner-portal-img2.svg": 216,
	"./portal/bloquote": 217,
	"./portal/bloquote.svg": 217,
	"./services/arrow-right": 218,
	"./services/arrow-right.svg": 218,
	"./services/services-card-img1": 219,
	"./services/services-card-img1.svg": 219,
	"./services/services-card-img2": 220,
	"./services/services-card-img2.svg": 220,
	"./services/services-card-img3": 221,
	"./services/services-card-img3.svg": 221,
	"./services/services-card-img4": 222,
	"./services/services-card-img4.svg": 222,
	"./specialize/item1": 223,
	"./specialize/item1.svg": 223,
	"./specialize/item10": 224,
	"./specialize/item10.svg": 224,
	"./specialize/item11": 225,
	"./specialize/item11.svg": 225,
	"./specialize/item12": 226,
	"./specialize/item12.svg": 226,
	"./specialize/item13": 227,
	"./specialize/item13.svg": 227,
	"./specialize/item14": 228,
	"./specialize/item14.svg": 228,
	"./specialize/item2": 229,
	"./specialize/item2.svg": 229,
	"./specialize/item3": 230,
	"./specialize/item3.svg": 230,
	"./specialize/item4": 231,
	"./specialize/item4.svg": 231,
	"./specialize/item5": 232,
	"./specialize/item5.svg": 232,
	"./specialize/item6": 233,
	"./specialize/item6.svg": 233,
	"./specialize/item7": 234,
	"./specialize/item7.svg": 234,
	"./specialize/item8": 235,
	"./specialize/item8.svg": 235,
	"./specialize/item9": 236,
	"./specialize/item9.svg": 236,
	"./specialize/item_bg": 237,
	"./specialize/item_bg.png": 237,
	"./specialize/mobile/item1": 238,
	"./specialize/mobile/item1.svg": 238,
	"./specialize/mobile/item10": 239,
	"./specialize/mobile/item10.svg": 239,
	"./specialize/mobile/item11": 240,
	"./specialize/mobile/item11.svg": 240,
	"./specialize/mobile/item12": 241,
	"./specialize/mobile/item12.svg": 241,
	"./specialize/mobile/item13": 242,
	"./specialize/mobile/item13.svg": 242,
	"./specialize/mobile/item14": 243,
	"./specialize/mobile/item14.svg": 243,
	"./specialize/mobile/item2": 244,
	"./specialize/mobile/item2.svg": 244,
	"./specialize/mobile/item3": 245,
	"./specialize/mobile/item3.svg": 245,
	"./specialize/mobile/item4": 246,
	"./specialize/mobile/item4.svg": 246,
	"./specialize/mobile/item5": 247,
	"./specialize/mobile/item5.svg": 247,
	"./specialize/mobile/item6": 248,
	"./specialize/mobile/item6.svg": 248,
	"./specialize/mobile/item7": 249,
	"./specialize/mobile/item7.svg": 249,
	"./specialize/mobile/item8": 250,
	"./specialize/mobile/item8.svg": 250,
	"./specialize/mobile/item9": 251,
	"./specialize/mobile/item9.svg": 251,
	"./specialize/specialize-in-bg": 252,
	"./specialize/specialize-in-bg.svg": 252,
	"./specialize/specialize_bg": 253,
	"./specialize/specialize_bg.jpg": 253,
	"./team-members/team-photo": 254,
	"./team-members/team-photo.jpg": 254,
	"./testing-solutions/solution-banner-icon": 255,
	"./testing-solutions/solution-banner-icon.svg": 255,
	"./trainings/coaches/coach-img-1": 256,
	"./trainings/coaches/coach-img-1.jpeg": 256,
	"./trainings/coaches/coach-img-2": 257,
	"./trainings/coaches/coach-img-2.jpeg": 257,
	"./trainings/counter-bg": 258,
	"./trainings/counter-bg.svg": 258,
	"./trainings/trainings-banner-icon": 259,
	"./trainings/trainings-banner-icon.svg": 259,
	"./video": 260,
	"./video.jpg": 260,
	"./video.webp": 271
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 262;